// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g8UT","colMin":"styles_colMin__2zhjd"};